import React from "react";
import reactCSS from "reactcss";

const styles = reactCSS({
  default: {
    page: {
      width: "100%",
      overflowY: "auto",
      padding: "20px",
      height: "calc(100vh - 60px)"
    }
  }
});

const Page = ({ otherClassName, children, ref }) => (
  <div className={`page ${otherClassName}`} style={styles.page} ref={ref}>
    {children}
  </div>
);

Page.defaultProps = {
  ref: () => {},
  otherClassNames: null
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/support/page/page.js